// assets
import { IconUsers } from '@tabler/icons-react';

// constant
const icons = { IconUsers };

const customerSetting = {
    id: 'customerSetting',
    title: 'Settings',
    type: 'group',
    children: [
        {
            id: 'default',
            title: 'User',
            type: 'item',
            url: 'customerSetting/userManagement/users',
            icon: icons.IconUsers,
            breadcrumbs: false
        }
    ]
};

export default customerSetting;
